import moment from 'moment';
import React, { useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { c } from '@debbie/cortex/dist/index.js';
import { selectUpdateTypes, selectUpdateTypesMap, } from '@debbie/cortex/dist/update-types/selectors.js';
import THEME from '../theme.js';
import Calendar from './Icons/Calendar.js';
import Pause from './Icons/Pause.js';
import PlusCircle from './Icons/PlusCircle.js';
import { RadioSelect, Input, SearchInput, Button } from './index.js';
var PauseOption;
(function (PauseOption) {
    PauseOption["NOW"] = "NOW";
    PauseOption["PAUSEAT"] = "PAUSEAT";
    PauseOption["CONTINUE"] = "CONTINUE";
})(PauseOption || (PauseOption = {}));
const NewPause = (props) => {
    const now = moment();
    const pauseTypeSearchInput = useRef(null);
    const lang = useSelector((s) => s.lang);
    const updateTypes = useSelector(selectUpdateTypes);
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    const [loadingNewPause, setLoadingNewPause] = useState(false);
    const [updateTypeId, setUpdateTypeId] = useState(null);
    const [note, setNote] = useState('');
    const [remindedAt, setRemindedAt] = useState(now);
    const [pauseOption, setPauseOption] = useState(PauseOption.NOW);
    const singleCase = props.case;
    const defaultUpdateType = updateTypeId && updateTypesMap[updateTypeId];
    const searchUpdateTypes = (q) => {
        if (!updateTypes)
            return [];
        return updateTypes
            .filter((uT) => {
            return (uT.selectable &&
                `${uT.label}${lang.updateTypes[uT.updateTypeId]}`
                    .toLocaleLowerCase()
                    .indexOf(q.toLocaleLowerCase()) !== -1);
        })
            .map((uT) => ({
            heading: lang.updateTypes[uT.updateTypeId] || uT.label,
            subheading: uT.groupLabel,
            key: uT.updateTypeId,
            returnData: uT,
        }))
            .sort((a, b) => (a.heading > b.heading ? 1 : 0) - (a.heading < b.heading ? 1 : 0));
    };
    const pauseCase = async () => {
        if (updateTypeId)
            setLoadingNewPause(true);
        try {
            if (!updateTypeId)
                throw 'Please select a type of update';
            await c.updates.make({
                referenceId: singleCase.caseId,
                updateTypeId: updateTypeId,
                update: note || null,
                remindedAt: remindedAt.format(),
                pausedAt: [PauseOption.NOW, PauseOption.CONTINUE].includes(pauseOption)
                    ? now === remindedAt
                        ? remindedAt.format()
                        : undefined
                    : remindedAt.format(),
                continuedAt: PauseOption.CONTINUE === pauseOption
                    ? remindedAt.format()
                    : undefined,
            });
            c.cases.getUpdates(singleCase.caseId);
            setUpdateTypeId(null);
            setNote('');
            setRemindedAt(now);
            setPauseOption(PauseOption.NOW);
            props.toggleNewUpdate();
        }
        catch (e) {
            console.error(e);
            alert('Error');
        }
        setLoadingNewPause(false);
    };
    const formattedDate = remindedAt.format(THEME.DATE_FORMAT_SHORT);
    return (singleCase && (React.createElement(StyledPause, null,
        React.createElement(PlusCircle, { style: {
                margin: '0.9em 0.4em 0.9em 0em',
            } }),
        React.createElement(InputWrapper, null,
            React.createElement("div", { style: { marginBottom: `-${THEME.GRID_SPACING}px` } },
                React.createElement(SearchInput, { autofocus: true, inputRef: pauseTypeSearchInput, onSelect: (uT) => {
                        setUpdateTypeId(uT.updateTypeId);
                    }, onRemoveStatic: () => {
                        setUpdateTypeId(null);
                    }, forceOpen: true, static: defaultUpdateType
                        ? lang.updateTypes[defaultUpdateType.updateTypeId] ||
                            defaultUpdateType.label
                        : null, searchDelay: 0, searchAll: searchUpdateTypes, className: "ui-test-3cf24ad6", placeholder: lang.cases.pauseReason }))),
        React.createElement(InputWrapper, null,
            React.createElement(Input, { value: note, style: { margin: `0px` }, placeholder: lang.cases.pauseComment, onChange: (e) => {
                    setNote(e.target.value);
                } })),
        // @ts-expect-error
        React.createElement(DatePicker, { "data-tooltip-id": "tooltip-bottom", "data-tooltip-content": lang.updates.dateSelectorTooltip, showTimeSelect: true, selected: remindedAt.toDate(), timeIntervals: 5, timeFormat: "HH:mm", popperPlacement: "bottom", customInput: React.createElement("div", null,
                React.createElement(Button, { theme: "secondary", style: { marginRight: `${THEME.GRID_SPACING}px` }, blockOnMobile: true },
                    React.createElement(Calendar, { style: {
                            margin: '0em 0.4em 0em 0em',
                        } }),
                    ' ',
                    now === remindedAt
                        ? lang.updates.remindNow
                        : remindedAt.format('Do MMMM YYYY, H:mm'))), 
            // @ts-expect-error
            onChange: (e) => setRemindedAt(moment(e)) }),
        React.createElement(OptionsWrapper, null, now !== remindedAt && (React.createElement(React.Fragment, null,
            React.createElement(RadioSelect, { active: pauseOption === PauseOption.NOW, key: PauseOption.NOW, label: lang.updates.pauseNow, onClick: () => setPauseOption(PauseOption.NOW) }),
            React.createElement(RadioSelect, { active: pauseOption === PauseOption.PAUSEAT, key: PauseOption.PAUSEAT, label: `${lang.updates.pauseUntilReminding} ${formattedDate}`, onClick: () => setPauseOption(PauseOption.PAUSEAT) }),
            React.createElement(RadioSelect, { active: pauseOption === PauseOption.CONTINUE, key: PauseOption.CONTINUE, label: `${lang.updates.pauseContinueAt} ${formattedDate}`, onClick: () => setPauseOption(PauseOption.CONTINUE) })))),
        React.createElement(Button, { blockOnMobile: true, loading: loadingNewPause, disabled: !updateTypeId, className: "ui-test-6ab08a95", onClick: pauseCase },
            React.createElement(Pause, { style: {
                    margin: '.2em 0 -.2em',
                } }),
            ' ',
            lang.cases.pauseCase))));
};
export default NewPause;
const StyledPause = styled.div `
  display: flex;
  justify-content: space-between;
  margin-bottom: ${THEME.GRID_SPACING}px;

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    display: block;
    .react-datepicker-wrapper,
    .react-datepicker__input-container {
      display: block;
    }
  }

  padding: ${THEME.GRID_SPACING}px;
  background-color: ${THEME.COLOR_SECONDARY};
  color: ${THEME.COLOR_PRIMARY};
  border-radius: 5px;
  box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);

  .react-datepicker-wrapper {
    width: auto !important;
  }
`;
const OptionsWrapper = styled.div `
  flex-grow: 1;
  padding: 9px 0;
`;
const InputWrapper = styled.div `
  margin-right: ${THEME.GRID_SPACING}px;

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    margin-right: 0px;
    margin-bottom: 20px;
  }
`;
//# sourceMappingURL=NewPause.js.map